const UseFieldConfig = (field) => {
    switch (field.field_type) {
        case 'alnum':
        case 'phone':
        case 'email':
        case 'string':
            return {
                label          : field.name,
                type           : "text",
                fieldSettings  : {
                    min: 0
                },
                mainWidgetProps: {
                    valueLabel      : field.name,
                    valuePlaceholder: `Enter ${field.name}`,
                }
            }
        case 'numeric':
            return {
                label          : field.name,
                type           : "number",
                fieldSettings  : {
                    min: 0
                },
                mainWidgetProps: {
                    valueLabel      : field.name,
                    valuePlaceholder: `Enter ${field.name}`,
                },
                preferWidgets  : ["number"]
            }

        case 'date':
        case 'datetime':
            return {
                label          : field.name,
                type           : "datetime",
                preferWidgets  : ["datetime"],
                mainWidgetProps: {
                    valueLabel      : field.name,
                    valuePlaceholder: `Enter ${field.name}`,
                },
                operators: [
                    'equal', 'not_equal', 'greater', 'greater_or_equal', 'less', 'less_or_equal',
                    'between'
                ]
            }

        default:
            return {
                label          : field.name,
                type           : "text",
                fieldSettings  : {
                    min: 0
                },
                mainWidgetProps: {
                    valueLabel      : field.name,
                    valuePlaceholder: `Enter ${field.name}`,
                }
            }
    }


}

export default UseFieldConfig;